"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const UpdateCase_1 = tslib_1.__importDefault(require("./UpdateCase"));
class EnrichmentFormSubmission extends UpdateCase_1.default {
}
exports.default = EnrichmentFormSubmission;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'S3 document ID of uploaded smart meter photo',
        example: 'emobility*account123$12345$essent',
    }),
    (0, class_transformer_1.Expose)({ name: 'smart_meter_photo' }),
    tslib_1.__metadata("design:type", String)
], EnrichmentFormSubmission.prototype, "smartMeterPhoto", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'S3 document ID of uploaded overview photo of the group box (NL: groepenkast)',
        example: 'emobility*account123$12345$essent',
    }),
    (0, class_transformer_1.Expose)({ name: 'group_box_photo' }),
    tslib_1.__metadata("design:type", String)
], EnrichmentFormSubmission.prototype, "groupBoxPhoto", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'S3 document ID of uploaded overview photo of the entire fuse box (NL: meterkast)',
        example: 'emobility*account123$12345$essent',
    }),
    (0, class_transformer_1.Expose)({ name: 'fuse_box_photo' }),
    tslib_1.__metadata("design:type", String)
], EnrichmentFormSubmission.prototype, "fuseBoxPhoto", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'S3 document ID of uploaded overview photo of the desired installation photo',
        example: 'emobility*account123$12345$essent',
    }),
    (0, class_transformer_1.Expose)({ name: 'installation_place_photo' }),
    tslib_1.__metadata("design:type", String)
], EnrichmentFormSubmission.prototype, "installationPlacePhoto", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'S3 document ID of uploaded overview photo of the entire fuse box (NL: meterkast)',
        example: 'emobility*account123$12345$essent',
    }),
    (0, class_transformer_1.Expose)({ name: 'crawl_space_photo' }),
    tslib_1.__metadata("design:type", String)
], EnrichmentFormSubmission.prototype, "crawlSpacePhoto", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'S3 document ID of the small ornamental pavement photo',
        example: 'emobility*account123$12345$essent',
    }),
    (0, class_transformer_1.Expose)({ name: 'small_ornamental_pavement_photo' }),
    tslib_1.__metadata("design:type", String)
], EnrichmentFormSubmission.prototype, "smallOrnamentalPavementPhoto", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'S3 document ID of the large ornamental pavement photo',
        example: 'emobility*account123$12345$essent',
    }),
    (0, class_transformer_1.Expose)({ name: 'large_ornamental_pavement_photo' }),
    tslib_1.__metadata("design:type", String)
], EnrichmentFormSubmission.prototype, "largeOrnamentalPavementPhoto", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates all required questions are answered and all required images uploaded',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'is_complete' }),
    tslib_1.__metadata("design:type", Boolean)
], EnrichmentFormSubmission.prototype, "isComplete", void 0);
